import React from "react";
import { Button, Popover } from "antd";
import styles from "./index.module.scss";
import useModalHandler from "utils/useModalHandler";
import ViewLog from "./Components/ViewLog";

interface ViewPublishLogProps {
    id: number;
}

export default function ViewPublishLog({ id }: ViewPublishLogProps) {
    const modal = useModalHandler();

    return (
        <span>
            <Popover
                title="发布履历"
                content={<ViewLog id={id} />}
                placement="bottomLeft">
                <Button
                    type="link"
                    className={styles.button}
                    onClick={modal.open}>
                    [查看发布履历]
                </Button>
            </Popover>
        </span>
    );
}
